import script from "./AuthView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=12560bda&lang=scss"

const __exports__ = script;

export default __exports__